<template>
  <v-app>
    <v-app-bar app fixed dark :color="Theme.PINK">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ app.APP_NAME }} v{{ getVersion }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="title">{{getUserInfo.name}}</span>
    </v-app-bar>
    <v-main class="overflow-main">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-navigation-drawer
        v-model="drawer"
        fixed
        temporary
        app>
      <v-list>
        <v-list-item v-for="item in menuList" :key="item.key"
                     @click="menuEvent(item)">
          <v-list-item-content>
            <v-list-item-title>{{item.label}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <alert-view/>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NoticeManager from '@/utils/notice_manager';
import AlertView from "@/components/AlertView";
import * as Constants from '@/utils/constants';
import common from "@/mixins/common";
import {LOGIN_USER, TOKEN_KEY} from "@/utils/constants";
export default {
  name: "NavigationView",
  components: {AlertView},
  mixins: [common],
  comments:{
    AlertView,
  },
  data(){
    return {
      drawer: false,
    };
  },
  created() {
    NoticeManager.addObserver(LOGIN_USER, (user) => {
      console.log(`user status ${JSON.stringify(user)}`);
      this.checkUserStatus();
    });
    NoticeManager.notifyObservers(LOGIN_USER);
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getVersion(){
      return Constants.APP_VERSION;
    },
    menuList() {
      let menuList = [];
      console.log(`getUserInfo ${JSON.stringify(this.getUserInfo)} `)
      if (this.isAdmin){
        menuList = [
          {key: 'home', path: '/admin/index', label: '首頁廣告圖片管理'},
          {key: 'news', path: '/admin/news', label: '公告管理'},
          {key: 'product', path: '/admin/product', label: '商品資料管理'},
          {key: 'order', path: '/admin/order', label: '訂單管理'},
          {key: 'orderNotShipped', path: '/admin/orderNotShipped', label: '未出貨列表'},
          {key: 'productImage', path: '/admin/productImage', label: '商品圖片管理'},
          {key: 'orderReport', path: '/admin/orderReport', label: '統計報表'},
          {key: 'instantDraw', path: '/admin/instantDraw', label: '即時抽況'},
          {key: 'user', path: '/admin/user', label: '會員資料管理'},
          {key: 'payment', path: '/admin/payment', label: '收款管理'},
          {key: 'invoice', path: '/admin/invoice', label: '發票管理'},
          {key: 'report', path: '/admin/report', label: '結算報表'},
          {key: 'lotteryRecord', path: '/admin/lotteryRecord', label: '刮刮樂紀錄'},
          {key: 'recycle', path: '/admin/recycle', label: '回收紀錄'},
          {key: 'vendor', path: '/admin/vendor', label: '商店設定'},
          {key: 'label', path: '/admin/label', label: '標籤管理'},
          {key: 'giveaway', path: '/admin/giveaway', label: '贈送代幣'},
          {key: 'paymentSetting', path: '/admin/paymentSetting', label: '付款設定'},
          {key: 'adminLottery', path: '/admin/adminLottery', label: '後台抽獎'},
          // {key: 'buyTicket', path: '/admin/buyTicket', label: '購買一抽券'},
          {key: 'worldBoss', path: '/admin/worldBoss', label: '世界Boss'},
          {key: 'logout', path: '/login', label: '登出'},
        ];
      } else if (this.isStaff){
        menuList = [
          {key: 'home', path: '/admin/index', label: '首頁廣告圖片管理'},
          {key: 'news', path: '/admin/news', label: '公告管理'},
          {key: 'product', path: '/admin/product', label: '商品資料管理'},
          {key: 'order', path: '/admin/order', label: '訂單管理'},
          {key: 'orderNotShipped', path: '/admin/orderNotShipped', label: '未出貨列表'},
          {key: 'productImage', path: '/admin/productImage', label: '商品圖片管理'},
          {key: 'instantDraw', path: '/admin/instantDraw', label: '即時抽況'},
          {key: 'user', path: '/admin/user', label: '會員資料管理'},
          {key: 'payment', path: '/admin/payment', label: '收款管理'},
          {key: 'lotteryRecord', path: '/admin/lotteryRecord', label: '刮刮樂紀錄'},
          {key: 'recycle', path: '/admin/recycle', label: '回收紀錄'},
          {key: 'label', path: '/admin/label', label: '標籤管理'},
          {key: 'giveaway', path: '/admin/giveaway', label: '贈送代幣'},
          {key: 'paymentSetting', path: '/admin/paymentSetting', label: '付款設定'},
          // {key: 'buyTicket', path: '/admin/buyTicket', label: '購買一抽券'},
          {key: 'logout', path: '/login', label: '登出'},
        ];
        if (this.getUserInfo.email === 'sophie12345511@gmail.com'
        || this.getUserInfo.email === 'huaaa001@gmail.com'){
          menuList.push( {key: 'report', path: '/admin/report', label: '結算報表'})
        }
      } else if (this.isVendor){
        menuList = [
          {key: 'vendor', path: '/admin/vendor', label: '商店設定'},
          {key: 'product', path: '/admin/product', label: '商品資料管理'},
          {key: 'productImage', path: '/admin/productImage', label: '商品圖片管理'},
          {key: 'order', path: '/admin/order', label: '訂單管理'},
          {key: 'report', path: '/admin/report', label: '結算報表'},
          {key: 'lotteryRecord', path: '/admin/lotteryRecord', label: '刮刮樂紀錄'},
          {key: 'recycle', path: '/admin/recycle', label: '回收紀錄'},
          //TODO 未完成暫不開放
          // {key: 'buyTicket', path: '/admin/buyTicket', label: '購買一抽券'},
          {key: 'logout', path: '/login', label: '登出'},
        ];
      }
      return menuList;
    },
  },
  methods:{
    ...mapActions(['logout', 'fetchUserInfo', 'configUserInfo']),
    async checkUserStatus(){
      const token = localStorage.getItem(TOKEN_KEY);
      console.log(`token == ${token}`);
      if (token) {
        const response = await this.fetchUserInfo();

        const result = response.data;
        console.log(`userInfo == ${JSON.stringify(result)}`);
        if (result && result.statusCode === 0) {
          const user = result.data;
          console.log(`user == ${JSON.stringify(user)}`);
          user.token = token;
          user.isLogin = true;
          await this.configUserInfo(user);
        } else {
          this.logout();
          await this.$router.push('/login');
        }
      } else {
        this.logout();
        await this.$router.push('/login');
      }
    },
    menuEvent(menu){
      console.log(`menuEvent == ${this.$router.currentRoute.path} ${menu.path}`)
      if (this.$router.currentRoute.path !== menu.path){
        if (menu.key === 'logout'){
          this.logout();
          this.$router.push('/login');
        } else {
          this.$router.push(menu.path);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
